import {isMobile} from '@/utils/features';

export default function (dom, opts) {
    let options = {
        overlaySel: '[data-overlay]',
        contentMainSel: '.organisation-content',
        openOverlaySel: '[data-open-overlay]',
        closeOverlaySel: '[data-close-overlay]',
        overlayShownCls: 'organisation-overlay-open',
        openOverlayCls: 'organisation-overlay--open',
        overlayNameSel: '.organisation-overlay__name',
        itemSel: '[data-values]',
        hideCls: 'hide-other-sections',
        defaultTitle: 'Choose a department',
        //mobile
        teamSectionNameSel: '.organisation__section',
        teamSectionInputSel: '.organisation__input',
        ...opts
    };

    const mainContent = document.body.querySelector(options.contentMainSel);
    const closeOverlay = dom.querySelector(options.closeOverlaySel);
    const overlayTitle = dom.querySelector(options.overlayNameSel);
    const teamSection = Array.from(dom.querySelectorAll(options.itemSel));

    const html = document.documentElement;
    const overlay = dom.querySelector(options.overlaySel);

    //mobile
    const deptSingle = Array.from(dom.querySelectorAll(options.teamSectionNameSel));
    const overlayTrigger = Array.from(dom.querySelectorAll(options.openOverlaySel));

    function init() {
        createPie();
        overlayClose();
    }


    function overlayClose() {
        closeOverlay.addEventListener('click', () => {
            overlay.classList.remove(options.openOverlayCls);
            html.classList.remove(options.overlayShownCls);
            overlayTitle.innerHTML = '';
        })
    }

    function createPie() {
        const radius = 400;
        const size = 2 * radius;
        const svg = makeSVG('svg', {
            width: size,
            height: size,
            viewBox: `0 0 ${size} ${size}`
        });
        const bgGroup = makeSVG('g');
        const defs = makeSVG('defs');
        const defaultTitle = options.defaultTitle;

        let title = document.createElement('h3');
        title.classList.add('dept-title');
        title.textContent = defaultTitle;

        const departments = options.departmentsList;

        let startAngle = 0;
        let endAngle = 0;

        svg.appendChild(defs);
        svg.appendChild(bgGroup);
        mainContent.appendChild(title);
        mainContent.appendChild(svg);

        for (let dept of departments) {
            const index = departments.indexOf(dept);
            let angle = 2 * Math.PI / departments.length;
            endAngle += angle;

            const pathStr =
                "M " + (radius) + "," + (radius) + " " +
                "L " + (Math.cos(startAngle) * radius + radius) + "," +
                (Math.sin(startAngle) * radius + radius) + " " +
                "A " + (radius) + "," + (radius) +
                " 0 " + (angle < Math.PI ? "0" : "1") + " 1 " +
                (Math.cos(endAngle) * radius + radius) + "," +
                (Math.sin(endAngle) * radius + radius) + " " +
                "Z";

            const svgPath = makeSVG('path', {
                d: pathStr,
                fill: `url(#image-${index})`,
                'data-open-overlay': '',
            });

            const pathTitle = makeSVG('title');
            pathTitle.innerHTML = dept.name;

            svgPath.appendChild(pathTitle);
            bgGroup.appendChild(svgPath);
            startAngle += angle;

            const svgPathBox = svgPath.getBBox();

            const pat = makeSVG('pattern', {
                id: `image-${index}`,
                patternUnits: 'userSpaceOnUse',
                x: svgPathBox.x,
                y: svgPathBox.y,
                width: svgPathBox.width,
                height: svgPathBox.height,
            });

            const img = makeSVG('image', {
                href: dept.image,
                x: 0,
                y: 0,
                width: svgPathBox.width,
                height: svgPathBox.height,
                preserveAspectRatio: 'xMidYMid slice',
            });

            pat.appendChild(img);
            defs.appendChild(pat);

            svgPath.addEventListener('mouseenter', e => {
                title.textContent = dept.name;
            });
            svgPath.addEventListener('mouseleave', e => {
                title.textContent = defaultTitle;
            });

            svgPath.addEventListener('click', e => {
                overlayOpen();
                applyFilter(dept.value);
            });

            function overlayOpen() {
                html.classList.add(options.overlayShownCls);
            }

            //start mobile
            if (isMobile()) {
                overlayTrigger.forEach(trigger => {
                    trigger.addEventListener('click', () => {
                        overlay.classList.add(options.openOverlayCls);
                        html.classList.add(options.overlayShownCls);
                        // overlayTitle.innerHTML = trigger.innerHTML;
                        //filter
                        filterSections();

                    })
                })

                function filterSections() {
                    deptSingle.forEach(dept => {
                        dept.addEventListener('click', () => {
                            applyFilter(dept.querySelector(options.teamSectionInputSel).value)
                        })
                    });
                }
            }
            //end mobile

            let teamValue;

            function applyFilter(value) {
                teamValue = value;
                teamSection.forEach(team => {
                    // create array with filterable values - data-value
                    const values = team.dataset.values.split(/,\s*/);
                    // search for current filter value
                    const active = teamValue ? values.includes(teamValue) : true;
                    team.classList.add(options.hideCls);

                    if (active) {
                        team.classList.remove(options.hideCls);
                    }
                })
            }
        }


        // SVG Maker - to draw SVG by script
        function makeSVG(tag, attrs) {
            const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
            for (let k in attrs)
                el.setAttribute(k, attrs[k]);
            return el;
        } //SVG Maker
    }

    init();
}


